import { useQuery } from '@apollo/client';

import type {
  CurrentAdvertiserContext,
  CurrentUserContext,
  GetLoggedInUserQuery,
  GetLoggedInUserQueryVariables,
} from 'src/graphql/generated';
import { LOGGED_IN_USER_DETAILS_QUERY } from 'src/graphql/gql_queries';
import type { UseQueryResponse } from 'src/types/types';

import { useAccountContext } from './use-account-context';

type LoggedInUser = Pick<
  CurrentUserContext & CurrentAdvertiserContext,
  'id' | 'firstName' | 'lastName' | 'email' | 'role'
>;

export const useLoggedInUser = (): UseQueryResponse<
  LoggedInUser | undefined
> => {
  const { data: accountContext } = useAccountContext();

  const { loading, error, data } = useQuery<
    GetLoggedInUserQuery,
    GetLoggedInUserQueryVariables
  >(LOGGED_IN_USER_DETAILS_QUERY, {
    skip: !accountContext,
  });

  if (
    data &&
    data.currentUser.__typename === 'CurrentUserContext' &&
    data.currentAdvertiser.__typename === 'CurrentAdvertiserContext'
  ) {
    const user = data && {
      ...data.currentUser,
      ...data.currentAdvertiser,
    };
    return { loading, error, data: user };
  }

  return { loading, error, data: null };
};
